import React, { useEffect } from 'react'
import { Navigate, NavigationType, Outlet, useNavigate } from 'react-router-dom'
import Cookies from "js-cookie";
const  VenderLayout = () => {
    const navigate = useNavigate()

    const venderUserID = Cookies.get("NIGHT_EYE_USER_ID")


    return (
       venderUserID ? <Outlet /> :<Navigate to={"/VendorLogin"} />
    )
}

export default VenderLayout
